export default {
      id: "oc-res-networkinterfaces-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-networkinterfaces",
      toString: function () {
        return this.url;
      }
    }